<template>
    <v-dialog v-model="dialog" max-width="500" @click:outside="$emit('closeHelpDialog')" class="rounded-xl">
    <v-card     class="mx-auto pa-3"
>
      <!-- <v-btn absolute
      right icon
      @click="$emit('closeHelpDialog')"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn> -->
        <v-card-title class="justify-start px-3">
          <!-- <v-icon class="mr-2" size="30">mdi-help-circle</v-icon> -->
            <span class="text-h5">Get help</span>
        </v-card-title>
        <v-window>
          <v-window-item :value="1">
            <v-card-text >
              AppBridge is here to make your experience seamless! While we currently showcase a select set of integrations, we're always eager to help. <br><br>If you have a specific need or can't find what you're looking for, just request a <b>custom integration</b> —we're excited to create a custom solution for you!
            </v-card-text>
          </v-window-item>

        </v-window>

        <v-card-actions>
          <v-btn  rounded depressed    @click="$emit('closeHelpDialog')" class="px-5">
                Close
            </v-btn>
            <v-spacer></v-spacer>

            <v-btn  rounded outlined color="primary"  @click="mailTo()" class="px-5">
                Contact
            </v-btn>

            <v-btn dark depressed rounded color="primary"  @click="onRequestCustomIntegration" class="mr-2 px-5 urbanist">
                Request
            </v-btn>

        </v-card-actions>
    </v-card>
</v-dialog>
</template>
<script>

export default {
  name: 'help-dialog',
  props: {
    showHelpDialog: Boolean
  },
  methods: {
    onRequestCustomIntegration () {
      this.showHelpSupportDialog = false
      // open sharepoint link in new tab
      window.open('https://collab.lilly.com/sites/AutomationEnablementTeam/SitePages/Automation-Intake-Form.aspx', '_blank')
    },
    mailTo () {
      window.open(`mailto:${process.env.VUE_APP_DEVELOPER_DL}`, '_blank')
    }
  },

  // use computed property to set the value of showHelpSupportDialog
  computed: {
    dialog: {
      get () {
        return this.showHelpDialog
      },
      set (value) {
      }
    }
  }

}
</script>
